/**
 * Returns the PostHog $groups context for the current credit union.
 * The credit union subdomain is embedded server-side into a <meta> tag
 * by _LayoutMWF.cshtml so that TypeScript modules can read it without
 * needing a global variable.
 */
export function getCreditUnionGroups(): Record<string, string> | undefined {
    const id = document.querySelector<HTMLMetaElement>('meta[name="posthog-cu-id"]')?.content;
    return id ? { credit_union: id } : undefined;
}
